import React, { useState, useRef, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import bild from '../App_Einstellungen.PNG';
import { Link } from "react-router-dom";
import {useNavigate} from "react-router-dom";

const Insight = () => {
    const navigate = useNavigate();

    useEffect(() => {  
    
        if (localStorage.getItem("loginData") == null) {
                
          navigate("/dhworld/login");
          
        } 
    }, []);

  return (
    <div
      style={{
        backgroundColor: '#eceff2',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      className="container-fluid"
    >
      <div className="container">
        <div className="row text-center justify-content-center">
          <div className='col-7 col-md-4 col-lg-3 col-sm-7'>
            <img className='img-fluid' src={bild} /><br /><br /><br />
            <h1>DH-Insight</h1><br />
          </div>
        </div>
        <div className="row justify-content-center align-items-center gy-4">
          <Link
            to="/insight/wartungsvertrag"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-files" style={{ fontSize: '30px' }}></i><br /><br />
              Wartungsverträge
            </div>
          </Link>

          <Link
            to="/insight/wartungsgeraet"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-display" style={{ fontSize: '30px' }}></i><br /><br />
              Geräte
            </div>
          </Link>

          <Link
            to="/insight/schluesselliste"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-key" style={{ fontSize: '30px' }}></i><br /><br />
              Schlüsselliste
            </div>
          </Link>

          <Link
            to="/insight/historie"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-clock-history" style={{ fontSize: '30px' }}></i><br /><br />
              Historie
            </div>
          </Link>

          
          <Link
            to="/insight/planer"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-pen" style={{ fontSize: '30px' }}></i><br /><br />
              MaterialFinder
            </div>
          </Link>

          <Link
            to="/insight/verzeichnis"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-signpost" style={{ fontSize: '30px' }}></i><br /><br />
              Gebäudeverzeichnis
            </div>
          </Link>

          <Link
            to="/insight/lagerartikel"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-box" style={{ fontSize: '30px' }}></i><br /><br />
              Lagerartikel
            </div>
          </Link>

          <Link
            to="/dhpick"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-person-workspace" style={{ fontSize: '30px' }}></i><br /><br />
              DHPICK
            </div>
          </Link>

          <Link
            to="/upload"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-cloud-upload" style={{ fontSize: '30px' }}></i><br /><br />
              Artikelbild-Upload
            </div>
          </Link>

          <Link
            to="/uploadarticle"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-cloud-upload" style={{ fontSize: '30px' }}></i><br /><br />
              Artikelbild-Upload DH-Carstock
            </div>
          </Link>

          <Link
            to="/carstock"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-ev-front" style={{ fontSize: '30px' }}></i><br /><br />
              DH-Carstock
            </div>
          </Link>

          <Link
            to="/materialanforderung"
            className="col-12 col-md-3 mx-md-2"
            style={{
              boxShadow: '0 7px 15px #00000012',
              cursor: 'pointer',
              padding: '.5rem',
              borderRadius: '10px',
              backgroundColor: '#fff',
              height: '300px',
              position: 'relative',
              overflow: 'hidden',
              textAlign: 'center',
              textDecoration: 'none',
              color: 'inherit',
            }}
          >
            <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
              <i className="bi bi-person-workspace" style={{ fontSize: '30px' }}></i><br /><br />
              Interne Materialanforderung
            </div>
          </Link>

        </div>
        <br></br> <br></br>
      </div>
    </div>
  );
};

export default Insight;
